import React from "react";

export default function CardClientes({ name, image, desc, title, rating }) {
  const totalStars = 5;

  return (
    <div className="  h-[400px] w-[350px] border-2 flex justify-center items-center dark:bg-sidom-blue border-sidom-orange   rounded-lg    overflow-hidden shadow-lg  dark:text-sidom-orange bg-sidom-light  p-4">
      <div className="mx-11  min-h-[300px] py-11">
        <div className="flex items-center  min-h-[70px] mb-2 ">
          <img
            className="w-12 h-12 rounded-full mr-4 object-cover"
            src={
              image ? `https://api.institucional.global.sidom.io${image}` : null
            }
            alt={`Foto de ${name}`}
          />
          <div className="text-sm min-h-[60px] ">
            <p className="dark:text-sidom-light text-sidom-dark font-semibold">
              {name}
            </p>
            <p className="dark:text-sidom-light text-sidom-dark text-xs">
              {title}
            </p>
          </div>
        </div>

        <div className="flex items-center mb-2">
          {[...Array(totalStars)].map((_, i) => (
            <svg
              key={i}
              className={`w-4 h-4 ${
                i < rating ? "text-sidom-orange" : "text-sidom-light"
              }`}
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.967a1 1 0 00.95.69h4.178c.969 0 1.371 1.24.588 1.81l-3.385 2.46a1 1 0 00-.364 1.118l1.287 3.966c.3.922-.755 1.688-1.54 1.118l-3.385-2.46a1 1 0 00-1.176 0l-3.385 2.46c-.784.57-1.838-.196-1.539-1.118l1.287-3.966a1 1 0 00-.364-1.118l-3.385-2.46c-.783-.57-.38-1.81.588-1.81h4.178a1 1 0 00.95-.69l1.286-3.967z" />
            </svg>
          ))}
        </div>

        <div className=" min-h-[200px] max-h-[210px] text-left">
          <p className="dark:text-sidom-light text-sidom-dark text-sm line-clamp-11 overflow-hidden text-ellipsis">
            {desc}
          </p>
        </div>
      </div>
    </div>
  );
}
